/*
 * Copyright © Siemens 2026
 */

import { Component } from '@angular/core';

@Component({
  selector: 'logo',
  templateUrl: './logo.html',
})
export default class Logo{}